import { Set, Map, List} from 'immutable';

import {FENCE_MAP_RESET,
        FENCE_MAP_CONCAT, 
        FENCE_MAP_FENCES_RESET,
        FENCE_MAP_CATEGORY_IDS_UPDATE,
        FENCE_MAP_ORGANIZATION_IDS_UPDATE,
        FENCE_MAP_VIEWPORT_UPDATE,
        FENCE_MAP_SHOW_LANDPARCEL_TOGGLE,
} from '../actions';

const defaultFilters = Map({
    topLeft: null,
    bottomRight: null,
    organizationIds: Set(),      // null => get fences for all organizations
    categoryIds: Set(),  // null => get fences for all categories
    lastUpdatedPage: 0,
    showLandparcels: false,
})

const fenceMap = (state = Map({filters: defaultFilters, fences: List()}), action) => {
  switch (action.type) {
    case FENCE_MAP_RESET:
        return Map({filters: defaultFilters, fences: []});
    case FENCE_MAP_FENCES_RESET:
        return state.setIn(['fences'], []);
    case FENCE_MAP_CONCAT:
        return state.setIn(['fences'], [...state.get('fences'), ...action.payload.fences]);
    case FENCE_MAP_CATEGORY_IDS_UPDATE:
        return state.setIn(['filters', 'categoryIds'], Set(action.payload.categoryIds));
    case FENCE_MAP_ORGANIZATION_IDS_UPDATE:
        return state.setIn(['filters', 'organizationIds'], Set(action.payload.organizationIds));
    case FENCE_MAP_VIEWPORT_UPDATE:
        return state.setIn(['filters','topLeft'], action.payload.topLeft)
                    .setIn(['filters','bottomRight'], action.payload.bottomRight);
    case FENCE_MAP_SHOW_LANDPARCEL_TOGGLE:
        return state.setIn(['filters', 'showLandparcels'], action.payload.value);
    default:
        return state
  }
}

export default fenceMap;


// WEBPACK FOOTER //
// ./src/organizations/reducers/map.js